import React from 'react';
import { Button } from 'ui';

const SkippedDisabledButtons = ({
  mediaButtonClass,
  disabledMediaButtonClass,
  recordButtonText,
  uploadButtonText,
}) => {
  return (
    <div className="QuestionElement-recordingActions">
      <div>
        <Button
          tall
          customColor
          disabled
          className={`${mediaButtonClass} ${disabledMediaButtonClass}`}
        >
          {recordButtonText}
        </Button>
      </div>
      <button
        type="button"
        className={`${mediaButtonClass} u-linkBtn h-td-n mt-8 fz-bigger c-gray-light`}
        disabled
      >
        {uploadButtonText}
      </button>
    </div>
  );
};

export default SkippedDisabledButtons;
